module.exports = __webpack_public_path__ + "static/meta-overview-700c451d4d0b89515c2e22c1f2e7ab51.png";